import React from 'react';
import { connect } from 'react-redux';
import { ButtonsItem, Buttons, Button } from './styled';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import {
    nextStepAction,
    showTariffAction,
    setTariffAction,
    isSendErrorActions, setRouterAction, setTvBoxAction
} from '~/src/store/actions/quiz';

import {
    checkAnswers,
    getProductNumber,
    selectProductById,
    dataLayerParams,
    getProductsAliasFromQuestions
} from '~/src/helpers/quiz';
import PropTypes from 'prop-types';
import { speedAnimation } from '../styled';

const Control = ({
     questions,
     stepQuiz,
     disabled,
     nextStep,
     showTariff,
     setTariff,
     tariffs,
     setIsSendError,
     routers,
     setRouter,
     tvBoxes,
     setTvBox,
     wrapper,
     setIsVisibleContent
}) => {

    const nextStepHandler = () => {

        const nextStepNumber = stepQuiz + 1;

        if (!checkAnswers(questions[stepQuiz].answers)) {
 return;
}

        if (nextStepNumber < questions.length) {

            const timeout = setTimeout(() => {

                if (wrapper) {
 wrapper.current.scrollTop = 0;
}

                nextStep(nextStepNumber);
                dataLayerPush(dataLayerParams({ category: 'quiz game', action: `step ${nextStepNumber}` }));

                clearTimeout(timeout);
            }, speedAnimation);
        }

        if (nextStepNumber === questions.length) {

            setIsVisibleContent(false);

            showTariff();
            dataLayerPush(dataLayerParams({ category: 'quiz game', action: `step ${nextStepNumber}` }));

            let tariff;
            let router;
            let tvBox;

            const aliases = getProductsAliasFromQuestions(questions);

            if (aliases.find(item => item === 'internet') || aliases.find(item => item === 'bundles')) {
                const alias = aliases.find(item => item === 'internet') ? 'internet' : 'bundles';
                tariff = selectProductById(tariffs, getProductNumber(questions, alias), alias);
            }

            if (aliases.find(item => item === 'router')) {
                router = selectProductById(routers, getProductNumber(questions, 'router'), 'router');
            }

            if (aliases.find(item => item === 'tv')) {
                tvBox = selectProductById(tvBoxes, getProductNumber(questions, 'tv'), 'tv');
            }

            if (tariff || router || tvBox) {
                if (tariff) {
 setTariff(tariff);
}
                if (router) {
 setRouter(router);
}
                if (tvBox) {
 setTvBox(tvBox);
}
            } else {
                setIsSendError(true);
            }

            const timeout = setTimeout(() => {

                if (wrapper) {
 wrapper.current.scrollTop = 0;
}

                clearTimeout(timeout);
            }, speedAnimation);

        }
    };

    return (
        <Buttons>
            <ButtonsItem>
                <Button
                    text={stepQuiz + 1 === questions.length ? 'Узнать результат' : 'Далее'}
                    onClick={nextStepHandler}
                    disabled={disabled}
                />
            </ButtonsItem>
        </Buttons>
    );
};

Control.propTypes = {
    stepQuiz: PropTypes.number,
    questions: PropTypes.array,
    nextStep: PropTypes.func,
    prevStep: PropTypes.func,
    stepQuizCheck: PropTypes.bool,
    showTariff: PropTypes.func,
    showError: PropTypes.func,
    currentCity: PropTypes.object,
    tariffs: PropTypes.array
};

Control.defaultProps = {
    stepQuiz: 0,
    questions: [],
    nextStep: () => null,
    stepQuizCheck: false,
    showTariff: () => null,
    setIsSendError: () => null,
    currentCity: {},
    tariffs: [],
};

const mapStateToProps = state => ({
    stepQuiz: state.quiz.stepQuiz,
    questions: state.quiz.questions,
    stepQuizCheck: state.quiz.stepQuizCheck,
    currentCity: state.city.currentCity,
    tariffs: state.quiz.tariffs,
    routers: state.routers,
    tvBoxes: state.tvBoxes.tvBoxes
});

const mapDispatchToProps = dispatch => ({
    nextStep: stepNumber => dispatch(nextStepAction(stepNumber)),
    showTariff: () => dispatch(showTariffAction()),
    setTariff: tariff => dispatch(setTariffAction(tariff)),
    setIsSendError: isSendError => dispatch(isSendErrorActions(isSendError)),
    setRouter: router => dispatch(setRouterAction(router)),
    setTvBox: tvBox => dispatch(setTvBoxAction(tvBox))
});

export default connect(mapStateToProps, mapDispatchToProps)(Control);
